<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link
              class="nav-link modern-nav-toggle"
              @click="toggleVerticalMenuActive"
            >
              <GjIcon
                name="Menu"
                class="d-block d-xl-none"
              />

            </b-link>
            <b-link @click="toggleCollapsed">
              <GjIcon
                name="Menu"
                class="d-none d-xl-block collapse-toggle-icon"
              />
            </b-link>
          </li>

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              class="navbar-brand"
              @click="changePlatform"
            >
              <span class="brand-logo">
                <b-img
                  :src="landingInfo.imageUrl"
                  alt="logo"
                />
              </span>
              <!-- <h2 class="brand-text">
                {{ appName }}
              </h2> -->
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <template v-if="!adminPlatform">
      <!-- <div
        :class="{'d-block': shallShadowBottom}"
        class="shadow-bottom"
      /> -->
      <b-skeleton
        v-if="loading"
        class="mx-1 mt-2"
        height="42px"
      />
      <div
        v-else
        class="px-1 pt-2 pb-0 account__modal"
      >
        <b-button
          v-b-modal.accounts-modal
          block
          variant="outline"
          class="p-0"
          size="sm"
          @click="openAccountList()"
        >
          <div class="w-100 d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <b-avatar
                size="34"
                rounded
                variant="light-primary"
                badge-variant="success"
                :src="accountContext.imageUrl"
              />
              <div class="account__modal-content pl-50">
                <span
                  v-if="!isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered)"
                  class="account__modal-name"
                >
                  {{ accountContext.name }}
                </span>
                <span class="account__modal-balance">
                  <span v-if="accountContext.balance !== null">
                    <span class="pr-25">
                      {{ $tk('ClientPortal.Form.Balance') }}
                    </span>
                    <span v-if="accountContext.balance > 1e6" v-b-tooltip.hover.bottomright
                      :title="accountBalanceFull">{{ accountBalance }}</span>
                    <span v-else>{{ accountBalance }}</span>
                  </span>
                </span>
              </div>
            </div>
            <GjIcon
              v-if="!isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered)"
              name="DoubleArrow"
              size="18"
            />
          </div>
        </b-button>
      </div>
      <hr class="m-0 mx-1 mt-2">
      <b-modal
        id="accounts-modal"
        ref="accountsModal"
        size="lg"
        :title="$tk('ClientPortal.AccountModal.Accounts')"
        centered
        body-class="modal-body--no-footer"
        hide-footer
      >
        <b-row class="mb-1">
          <b-col sm="7">
            <SearchInputField
              :placeholder="$tk('ClientPortal.Form.SearchAccount')"
              @onInputSearch="loadAccounts"
            />
          </b-col>
          <b-col
            class="text-right"
            sm="5"
          >
            <b-button
              variant="primary"
              size="sm"
              to="/account/create"
            >
              <GjIcon
                class="mr-50"
                name="Plus"
              />
              {{ $tk('ClientPortal.AccountModal.CreateAccount') }}
            </b-button>
          </b-col>
        </b-row>
        <h6>
          {{ $tk('ClientPortal.AccountModal.CurrentAccount') }}
        </h6>

        <b-list-group
          class="mb-1"
          flush
        >
          <b-list-group-item>
            <b-avatar
              class="mr-50"
              size="sm"
              rounded
              :src="accountContext.imageUrl"
            />
            {{ accountContext.name }}
          </b-list-group-item>
        </b-list-group>
        <h6>
          {{ $tk('ClientPortal.AccountModal.OtherAccounts') }}
        </h6>
        <scroll-container height-offset="370px">
          <b-list-group
            id="account-modal-list"
            flush
          >
            <account-avatar-skeleton
              v-if="loadingAccounts"
            />
            <b-list-group-item
              v-for="(account, range) in accounts"
              v-else
              :key="`${account.id}-${range}`"
              @click="changeAccount(account)"
            >
              <b-avatar
                class="mr-50"
                size="sm"
                rounded
                :src="account.imageUrl"
              />
              {{ account.name }}
            </b-list-group-item>
          </b-list-group>
        </scroll-container>

      </b-modal>
    </template>
    <!-- main menu content-->

    <scroll-container
      height-offset="136px"
    >
      <vertical-nav-menu-items
        :key="!adminPlatform ? 'clientItems': 'adminItems'"
        :items="!adminPlatform ? clientItems: adminItems"
        class="navigation navigation-main pt-0"
        :class="!adminPlatform ? '': 'mt-1'"
      />
    </scroll-container>
    <!-- <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >

    </vue-perfect-scrollbar> -->
    <!-- /main menu content-->
  </div>
</template>

<script>
// import navMenuItems from '@/navigation/vertical'
import clientItems from '@/navigation/client/client'
import adminItems from '@/navigation/admin/admin'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import ScrollContainer from '@/components/ScrollContainer.vue'
import AccountsService from '@/api/client/accounts.service'
import {
  mapGetters,
  mapActions,
} from 'vuex'
import SearchInputField from '@/components/SearchInputField.vue'
import AccountAvatarSkeleton from '@/components/AccountSkeleton.vue'
import { formatCurrency } from '@/utils/currency'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    ScrollContainer,
    VerticalNavMenuItems,
    BLink,
    BImg,
    GjIcon,
    SearchInputField,
    AccountAvatarSkeleton,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      appLogoImage: 'https://www.mall.tv/Content/malltv/img/malltv-logo.png',
      loadedAccounts: false,
      loadingAccounts: false,
      searchTerm: '',
      accounts: [],
    }
  },
  computed: {
    ...mapGetters('verticalMenu', ['accountContext']),
    ...mapGetters(['landingInfo']),
    ...mapGetters('verticalMenu', ['adminPlatform']),
    ...mapGetters('verticalMenu/', ['loading']),
    accountBalance() {
      const bal = this.accountContext.balance
      if (typeof bal !== 'number' || Number.isNaN(bal)) return 'N/A'
      if (bal > 1e6) return `${this.formatUsers(bal)} ${this.$currencySymbol}`
      return formatCurrency(bal)
    },
    accountBalanceFull() {
      return formatCurrency(this.accountContext.balance)
    },
  },
  watch: {
    '$route.params.accountId': 'reloadAccountContext',
  },
  beforeCreate() {
    this.$store.commit('verticalMenu/setLoading', true)
  },
  async beforeMount() {
    const { accountId } = this.$route.params
    if (!accountId) {
      await this.getDefaultAccount()
    }
  },
  mounted() {
    const { accountId } = this.$route.params
    if (accountId) { this.changeAccountContext(accountId) }
  },
  methods: {
    ...mapActions('verticalMenu', ['changeAccountContext', 'getDefaultAccount']),
    reloadAccountContext() {
      const { accountId } = this.$route.params
      if (accountId !== undefined) { this.changeAccountContext(this.$route.params.accountId) }
    },
    openAccountList() {
      this.searchTerm = ''
      if (!this.loadedAccounts) {
        this.loadAccounts(this.searchTerm)
      }
    },
    async loadAccounts(searchTerm) {
      this.searchTerm = searchTerm
      if (this.loadingAccounts) { return }

      this.loadingAccounts = true
      const response = await AccountsService.list(this.searchTerm, this.$route.params.accountId)
      this.accounts = response
      this.loadingAccounts = false
    },
    changeAccount(account) {
      // Redirect to surveys list when switching accounts from survey detail/edit pages
      if (this.$route.name === 'surveyDetails' || this.$route.name === 'editSurvey') {
        this.$router.push({ name: 'surveys', params: { accountId: account.id } })
      } else {
        this.$router.push({ name: this.$route.name, params: { accountId: account.id } })
      }
      this.$refs.accountsModal.hide()
    },
    changePlatform() {
      const { accountId } = this.$store.getters['verticalMenu/accountContext']
      if (accountId) { this.$router.push(`/${accountId}`) } else { this.$router.push('/') }
      this.$store.commit('verticalMenu/changePlatform', false)
    },
    formatUsers(value) {
      if (value >= 1e6 && value < 1e9) return `${+(value / 1e6).toFixed(2)}M`
      if (value >= 1e9 && value < 1e12) return `${+(value / 1e9).toFixed(2)}B`
      return value
    },
    clearSearchInput() {
      this.searchTerm = ''
      this.loadAccounts()
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'Menu' : 'Close'))

    // App Name
    const { appName } = $themeConfig.app

    return {
      // navMenuItems,
      clientItems,
      adminItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";

.brand-logo img {
  max-width: 140px!important;
}

/*TODO: Change this in a better way*/
/*Leaving it to a front developer*/
#account-modal-list .list-group-item {
  cursor: pointer !important;
}
</style>
